import classes from "./highlights.module.scss";
import SimpleCarousel from "../../../generic components/SimpleCarousel/SimpleCarousel";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import fallbackImg from "../../../assets/imgs/notFound/fallback-image.png";
import { useState } from "react";

function Highlights(props) {
  const { highlights } = props;
  const [images, setImages] = useState(highlights?.map((card) => card.image));

  const handleImageError = (index) => {
    setImages((images) => {
      const newImages = [...images];
      newImages[index] = fallbackImg;
      return newImages;
    });
  };

  return (
    <>
      <SimpleCarousel
        className={classes.carousel}
        mouseTracking
        autoPlay={true}
        autoPlayInterval={5000}
        infinite={true}
        items={highlights?.map((card, index) => (
          <div className={classes.highlightCard} key={index}>
            <img
              src={images[index] || fallbackImg}
              className={classes.highlightImg}
              alt={card.title}
              onError={() => handleImageError(index)}
            />
            <div className={classes.highlightTitle}>{card.title}</div>
            <div
              className={classes.highlightInfo}
              dangerouslySetInnerHTML={{ __html: card.description }}
            ></div>
          </div>
        ))}
        responsive={{
          0: {
            items: 1,
            itemsFit: "contain",
          },
        }}
        disableDotsControls={true}
      />
    </>
  );
}

export default Highlights;
